import React, { useState, useEffect } from 'react'
import { Row, Table, ButtonGroup } from 'rsuite'
import TooltipButton from '../../components/buttons/TooltipButton'
const { Column, HeaderCell, Cell } = Table

export default function AttachFilesView({ schema, onPreview, onDownload, autoHeight, ...props }) {
  const [filelist, setFilelist] = useState([])

  useEffect(() => {
    setFilelist(schema.value || schema.values || [])
  }, [schema])

  return (
    <Row style={{ marginBottom: '2em' }}>
      <Table autoHeight={autoHeight} height={500} wordWrap bordered data={filelist}>
        <Column width={90} align="center" fixed>
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>

        <Column width={190}>
          <HeaderCell>หมวดหมู่ไฟล์</HeaderCell>
          <Cell dataKey="fileCategory" />
        </Column>

        <Column width={300}>
          <HeaderCell>ชื่อไฟล์</HeaderCell>
          <Cell dataKey="label" />
        </Column>

        <Column width={330} minWidth={330} flexGrow={1}>
          <HeaderCell>หมายเหตุ</HeaderCell>
          <Cell dataKey="note" />
        </Column>

        <Column width={150} align="center" fixed="right">
          <HeaderCell></HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <ButtonGroup>
                  <TooltipButton
                    icon="eye"
                    tooltip={`แสดง`}
                    onClick={(e) => onPreview(rowData)}
                  ></TooltipButton>
                  <TooltipButton
                    icon="download"
                    tooltip={`ดาวน์โหลด`}
                    onClick={(e) => onDownload(rowData)}
                  ></TooltipButton>
                </ButtonGroup>
              )
            }}
          </Cell>
        </Column>
      </Table>
    </Row>
  )
}
